import { Navigate } from "react-router-dom";
export default function ReviewDetailPage() {
  return <Navigate to="/forex/agents/audit" replace />;
}
